export default __webpack_public_path__ + "static/media/holidays.7b073e6c.jpg";